import { LayoutDashboard } from 'lucide-react';
import type { ModuleMeta } from '../types';

export const meta: ModuleMeta = {
  id: 'dashboard',
  label: 'Dash',
  route: '/dash',
  icon: LayoutDashboard,
};
